module.exports = __webpack_public_path__ + "static/img/icon-jinblog.dafed9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon-jinblog.png
// module id = 141
// module chunks = 1